import * as React from "react";

import styles from "./SignatoryCard.module.css";
import { ProgressBar } from "../ProgressBar/ProgressBar";

export interface SignatoryCardProps {
  /** short role label, e.g. "Генподрядчик" */
  sub: string;
  /** organisation name; empty => placeholder */
  orgName?: string;
  placeholder?: string;
  repLine?: string;
  selected: boolean;
  filled: number;
  total: number;
  onSelect: () => void;
  className?: string;
  saved?: boolean;
}

const dotColor = (filled: number, total: number, saved?: boolean): string => {
  if (total > 0 && filled >= total && saved) return "var(--progress-green)";
  if (filled === 0) return "var(--progress-red)";
  return "var(--progress-amber)";
};

/** Selectable participant card in the signatories master list. */
export const SignatoryCard: React.FC<SignatoryCardProps> = ({
  sub, orgName, placeholder = "Не заполнено", repLine, selected, filled, total, onSelect, className, saved
}) => {
  const percent = total > 0 ? Math.round((filled / total) * 100) : 0;
  return (
    <div
      onClick={onSelect}
      className={`${styles.card}${selected ? ` ${styles.selected}` : ``}${className ? ` ${className}` : ``}`}
    >
      <div className={styles.top}>
        <div className={styles.info}>
          <div className={styles.sub}>{sub}</div>
          <div className={`${styles.org}${orgName ? `` : ` ${styles.placeholder}`}`}>
            {orgName || placeholder}
          </div>
          {repLine && (
            <div className={styles.rep}>
              <i className="fa-regular fa-user" />
              {repLine}
            </div>
          )}
        </div>
        <span className={styles.dot} style={{ background: dotColor(filled, total, saved) }} />
      </div>
      <div className={styles.progressRow}>
        <ProgressBar percent={percent} size="md" />
        <span className={styles.count}>{filled}/{total}</span>
      </div>
    </div>
  );
};
